import { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { PrimaryButton } from 'shared/components/button'
import { AccessDenied } from 'shared/errors/access-denied'
import { UnauthorizedResponse } from 'shared/errors/unauthorized-response'
import { useJoinCommunity } from '../api/use-join-community'

function JoinForm({
  showRegistration,
  disabled,
}: {
  showRegistration: () => void
  disabled: boolean
}): ReactNode {
  const router = useRouter()
  const { t } = useTranslation()
  const { communityPath } = router.query
  const joinCommunityMutation = useJoinCommunity()

  async function join(): Promise<void> {
    if (!communityPath) return
    try {
      await joinCommunityMutation.mutateAsync(communityPath)
      await router.replace(`/community/${communityPath}`)
    } catch (error) {
      if (error instanceof UnauthorizedResponse) {
        showRegistration()
      } else if (error instanceof AccessDenied) {
        await router.replace(`/community/403`)
      }
    }
  }

  return (
    <PrimaryButton
      isLoading={joinCommunityMutation.isPending}
      disabled={disabled || joinCommunityMutation.isPending}
      onClick={join}
    >
      {t('join_form.button.join.title')}
    </PrimaryButton>
  )
}

export default JoinForm
